import type { AnyAction, Reducer } from 'redux';

import type { SessionConfigureAction } from '../../../domains/sessionConfigure/actions.types';

import type { SubstrateConfig } from './types';

export type SubstrateAction = SessionConfigureAction;

const initialState: SubstrateConfig = {
  pushSubscriptionKeyPath: '',
  pushSubscriptionsPath: '',
  pushSubscriptionsPublicKey: '',
};

const reducer: Reducer<SubstrateConfig, SubstrateAction | AnyAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'SESSION.CONFIGURE':
      return action.payload.substrate ?? state;
    default:
      return state;
  }
};

export default reducer;
